import { Box, Grid, Link, Divider, InputLabel, CircularProgress, Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material';
import { AuthContext, Ico_Plus, IUser } from '@sagecentral/core-ui';
import { useContext, useEffect, useState } from 'react';
import { ProjectContext } from "components/projects/project-layout";
import { useProjectPermissions, useProjectWorkItems } from 'hooks/projects';
import { useFeatureEnabled } from 'hooks/shared';
import { WorkflowTasksCard } from 'components/workflows';
import { IWorkItemWorkflow } from 'models/work-items';
import { IWorkitem } from 'models/projects/Workitem/Workitem';

const KeyGrid = styled(Grid)({
    fontWeight: "bold"
});

type ProjectWorkItemSectionProps = {
    workItem: IWorkitem;
    showAll: boolean;
    onRefresh?: () => void;
};

const ProjectWorkItemSection = (props: ProjectWorkItemSectionProps) => {
    const { workItem, showAll, onRefresh } = props;

    const permissions = useProjectPermissions();

    const canEditWf = permissions?.canEditWorkflows ?? false;
    const canCreateWf = permissions?.canCreateWorkflows;
    const canActivateWf = permissions?.canActivateWorkflows ?? false;
    const canDeactivateWf = permissions?.canDeactivateWorkflows ?? false;

    const workflowCreateUrl = `${process.env.REACT_APP_CLASSIC_URL}/WorkflowInstance/CreateWorkflowInstance?workItemID=${workItem?.id}`;

    return (
        <Box>                            
            {canCreateWf && <Box sx={{ justifyContent: 'start' }}>                
                <Button sx={{ 
                        width: '220px', 
                        height: '40px',
                        mb: 2,
                        ml: 0
                    }} 
                    variant="outlined" 
                    href={workflowCreateUrl}
                    startIcon={<Ico_Plus />}
                >
                    Add New Workflow
                </Button>
            </Box>}
            {workItem && workItem?.workflows?.length > 0 ? workItem?.workflows?.map((workflowTemplate: IWorkItemWorkflow) => {                
                return (
                    <WorkflowTasksCard 
                        key={`${workflowTemplate.id}`}
                        workflow={workflowTemplate} 
                        canEdit={canEditWf} 
                        canActivate={canActivateWf} 
                        canDeactivate={canDeactivateWf} 
                        project 
                        showAll={showAll}
                        refresh={onRefresh}
                    />
                )
            }) : <Box sx={{ paddingBottom: '16px' }}>No associated workflow.</Box>}
        </Box>
    );
};

const WorkItemsWorkflows = (props: any) => {
    const auth = useContext(AuthContext);
    const localTheme = useTheme();
    const theme = props.theme ?? localTheme;
    const { projectId, filter, statusFilter } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [wave4Enabled] = useFeatureEnabled('wave-4');
    const [refreshKey, setRefreshKey] = useState<number>(0);

    // Function to trigger a refresh
    const handleRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    // useEffect to re-fetch data when refreshKey changes
    useEffect(() => {
        // This effect will run whenever refreshKey changes
    }, [refreshKey]);

    const [projectWorkitems, loading, error] = useProjectWorkItems(projectId, statusFilter);

    const project = useContext(ProjectContext);

    return (

        <Box>
            {(isLoading || loading) && (!projectWorkitems || projectWorkitems?.totalItems === 0) && <CircularProgress color="primary" />}
            {(!isLoading && !loading) && (!projectWorkitems || projectWorkitems?.totalItems === 0) && <><br /><br /><br /><br /><Typography sx={{ textAlign: "center" }} variant='subtitle1' color={theme.palette.common.black}>No work items found.</Typography></>}
            {projectWorkitems?.projectWorkItems?.map((workitem, index) => {
                return (
                    <Box key={index}>
                        <Grid container >
                            <Grid xs={12} display="flex" alignItems="center" sx={{ fontWeight: 600 }}>
                                <KeyGrid>Work Item:</KeyGrid>
                                <Grid sx={{ paddingLeft: '5px' }}></Grid>
                                <Link sx={{ display: 'flex' }}
                                    href={process.env.REACT_APP_PUBLIC_URL + `/workitems/${workitem.id}/overview`}>
                                    {workitem.name}
                                    <Typography sx={{ color: 'black', fontWeight: 600, fontSize: 'inherit' }}>&nbsp;{`(${workitem.id})`}</Typography>
                                </Link>
                            </Grid>
                            <Grid sx={{ paddingTop: '8px' }} xs={8} container>
                                <KeyGrid>Content Type:</KeyGrid>
                                <Grid sx={{ paddingLeft: '5px' }}>{workitem.contentType}</Grid>
                            </Grid>
                        </Grid>
                        <br />
                        <ProjectWorkItemSection workItem={workitem} showAll={props.showAll} onRefresh={handleRefresh}/>
                        <Divider sx={{ marginTop: '20px' }} />
                        <br />
                    </Box>
                )
            })
            }
        </Box>
    );
};

export default WorkItemsWorkflows;